import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/circleci/project/layouts/default.vue").then(m => m.default || m)),
  privacy: defineAsyncComponent(() => import("/home/circleci/project/layouts/privacy.vue").then(m => m.default || m))
}